import { render, staticRenderFns } from "./TakeCompanionMemberPopup.vue?vue&type=template&id=6c27f993&"
import script from "./TakeCompanionMemberPopup.vue?vue&type=script&lang=js&"
export * from "./TakeCompanionMemberPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports